import {
   amountColumnValueSetter,
   carrierCodeValueSetter,
   currencyCodeValueSetter,
   destinationValueSetter,
   discontinueDateValueSetter,
   effectiveDateValueSetter,
   fareClassCodeValueSetter,
   footnoteCodeValueSetter,
   originValueSetter,
   roundTripIndicatorValueSetter,
   routingNumberValueSetter,
   tariffNumberValueSetter,
} from '../../../utils/column-validators';
import { USER_ACTION_CODE_FARES_SCREEN } from '../../../utils/constants';

export const specifiedFaresTableHeaders = [
   {
      headerName: 'IDENTIFIER',
      headerComponentParams: { tooltip: 'Identifier' },
      children: [
         {
            field: 'origin',
            headerName: 'ORG',
            headerComponentParams: { tooltip: 'Origin' },
            pinned: 'left',
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: originValueSetter,
         },
         {
            field: 'destination',
            headerName: 'DES',
            headerComponentParams: { tooltip: 'Destination' },
            pinned: 'left',
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: destinationValueSetter,
         },
         {
            field: 'carrierCode',
            headerName: 'CXR',
            headerComponentParams: { tooltip: 'Carrier Code' },
            pinned: 'left',
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: carrierCodeValueSetter,
         },
         {
            field: 'fareClassCode',
            headerName: 'FBC',
            headerComponentParams: { tooltip: 'Fare Class Code' },
            pinned: 'left',
            minWidth: 72,
            maxWidth: 72,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: fareClassCodeValueSetter,
         },
         {
            field: 'tariffNumber',
            headerName: 'TAR',
            headerComponentParams: { tooltip: 'Tariff Number' },
            pinned: 'left',
            cellStyle: { textAlign: 'right' },
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: tariffNumberValueSetter,
         },
         {
            field: 'footnoteCode',
            headerName: 'FT',
            headerComponentParams: { tooltip: 'Footnote Code' },
            pinned: 'left',
            maxWidth: 50,
            editable: true,
            valueSetter: footnoteCodeValueSetter,
         },

         {
            field: 'routingNumber',
            headerName: 'RTG',
            headerComponentParams: { tooltip: 'Routing Number' },
            pinned: 'left',
            maxWidth: 50,
            cellStyle: { textAlign: 'right' },
            editable: true,
            valueSetter: routingNumberValueSetter,
         },
         {
            field: 'constructionMethod',
            headerName: 'CON',
            headerComponentParams: { tooltip: 'Construction Method' },
            pinned: 'left',
            maxWidth: 50,
         },
      ],
   },
   {
      headerName: 'FARE VALUE',
      headerComponentParams: { tooltip: 'Fare Value' },
      children: [
         {
            field: 'vendorChangeCode',
            headerName: 'VCC',
            headerComponentParams: { tooltip: 'Vendor Change Code' },
            maxWidth: 50,
         },
         {
            field: 'roundTripIndicator',
            headerName: 'OWRT',
            headerComponentParams: { tooltip: 'Round Trip Indicator' },
            maxWidth: 50,
            cellStyle: { textAlign: 'right' },
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: roundTripIndicatorValueSetter,
         },
         {
            field: 'currencyCode',
            headerName: 'CUR',
            headerComponentParams: { tooltip: 'Currency Code' },
            maxWidth: 50,
            editable: true,
            valueSetter: currencyCodeValueSetter,
         },
         {
            field: 'fareAmount',
            headerName: 'AMT',
            headerComponentParams: { tooltip: 'Fare Amount' },
            maxWidth: 72,
            cellStyle: { textAlign: 'right' },
            editable: true,
            valueSetter: amountColumnValueSetter,
         },
         {
            field: 'surchargeAmount',
            headerName: 'SUR',
            headerComponentParams: { tooltip: 'Surcharge Amount' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'yqAmount',
            headerName: 'YQ',
            headerComponentParams: { tooltip: 'YQ Amount' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'yrAmount',
            headerName: 'YR',
            headerComponentParams: { tooltip: 'YR Amount' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'aggregatedTax',
            headerName: 'TAX',
            headerComponentParams: { tooltip: 'Aggregated Tax' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'totalFare',
            headerName: 'TTL',
            headerComponentParams: { tooltip: 'Total Fare' },
            maxWidth: 56,
            cellStyle: { textAlign: 'right' },
         },
      ],
   },
   {
      headerName: 'RULE',
      headerComponentParams: { tooltip: 'Rule' },
      children: [
         {
            field: 'ruleNumber',
            headerName: 'RULE',
            headerComponentParams: { tooltip: 'Rule Number' },
            maxWidth: 50,
         },
         {
            field: 'dow',
            headerName: 'DOW',
            headerComponentParams: { tooltip: 'Day of Week' },
            maxWidth: 140,
         },
         {
            field: 'ruleSeasonDates',
            headerName: 'SEAS DT',
            headerComponentParams: { tooltip: 'Season Dates' },
            maxWidth: 136,
            tooltipField: 'ruleSeasonDates',
         },
         {
            field: 'advancePurchaseReservation',
            headerName: 'AP',
            headerComponentParams: { tooltip: 'Advance Purchase Reservation' },
            maxWidth: 50,
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'ruleTravelDates',
            headerName: 'RULE TVL DT',
            headerComponentParams: { tooltip: 'Rule Travel Dates' },
            maxWidth: 136,
            tooltipField: 'ruleTravelDates',
         },
         {
            field: 'applicableDates',
            headerName: 'APPL DT',
            headerComponentParams: { tooltip: 'Applicable Dates' },
            maxWidth: 136,
            tooltipField: 'applicableDates',
         },
         {
            field: 'minStay',
            headerName: 'MIN ST',
            headerComponentParams: { tooltip: 'Minimum Stay' },
            maxWidth: 136,
            tooltipField: 'minStay',
         },
         {
            field: 'maxStay',
            headerName: 'MAX ST',
            headerComponentParams: { tooltip: 'Maximum Stay' },
            tooltipField: 'maxStay',
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'ruleBlackOutDates',
            headerName: 'BO DT',
            headerComponentParams: { tooltip: 'Black Out Dates' },
            maxWidth: 136,
            tooltipField: 'ruleBlackOutDates',
            cellStyle: { textAlign: 'right' },
         },
      ],
   },
   {
      headerName: 'FOOTNOTE',
      headerComponentParams: { tooltip: 'Footnote' },
      children: [
         {
            field: 'footnoteReservationFromDate',
            headerName: 'FST RES',
            headerComponentParams: {
               tooltip: 'Footnote Reservation From Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteReservationToDate',
            headerName: 'LST RES',
            headerComponentParams: { tooltip: 'Footnote Reservation To Date' },
            maxWidth: 76,
         },
         {
            field: 'footnoteTicketingFromDate',
            headerName: 'FST TKT',
            headerComponentParams: { tooltip: 'Footnote Ticketing From Date' },
            maxWidth: 76,
         },
         {
            field: 'footnoteTicketingToDate',
            headerName: 'LST TKT',
            headerComponentParams: { tooltip: 'Footnote Ticketing To Date' },
            maxWidth: 76,
         },
         {
            field: 'footnoteOutboundTravelFromDate',
            headerName: 'TVL ST',
            headerComponentParams: {
               tooltip: 'Footnote Outbound Travel From Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteOutboundTravelToDate',
            headerName: 'TVL END',
            headerComponentParams: {
               tooltip: 'Footnote Outbound Travel To Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteOutboundTravelCompleteDate',
            headerName: 'TVL CMPLT',
            headerComponentParams: {
               tooltip: 'Footnote Outbound Travel Complete Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteTravelDates',
            headerName: 'FT TVL DT',
            headerComponentParams: { tooltip: 'Footnote Travel Dates' },
            maxWidth: 136,
            tooltipField: 'footnoteTravelDates',
         },
         {
            field: 'footnoteSeasonDates',
            headerName: 'FT SEAS DT',
            headerComponentParams: { tooltip: 'Footnote Season Dates' },
            maxWidth: 136,
            tooltipField: 'footnoteSeasonDates',
         },
         {
            field: 'footnoteBlackOutDates',
            headerName: 'FT BO DT',
            headerComponentParams: { tooltip: 'Footnote Black Out Dates' },
            maxWidth: 136,
            tooltipField: 'footnoteBlackOutDates',
         },
      ],
   },
   {
      headerName: 'DISTRIBUTION',
      headerComponentParams: { tooltip: 'Distribution' },
      children: [
         {
            field: 'effectiveDate',
            headerName: 'EFF DT',
            headerComponentParams: { tooltip: 'Effective Date' },
            maxWidth: 70,
            editable: true,
            valueSetter: effectiveDateValueSetter,
         },
         {
            field: 'discontinueDate',
            headerName: 'DISC DT',
            headerComponentParams: { tooltip: 'Discontinue Date' },
            maxWidth: 70,
            editable: true,
            valueSetter: discontinueDateValueSetter,
         },
         {
            field: 'receivedDate',
            headerName: 'REC DT',
            headerComponentParams: { tooltip: 'Transmission Date Time' },
            maxWidth: 132,
         },
         {
            field: 'gfsUniqueFillingCode',
            headerName: 'GFS',
            headerComponentParams: { tooltip: 'GFS Unique Filling Code' },
            maxWidth: 50,
         },
         {
            field: 'gfsDate',
            headerName: 'GFS DT',
            headerComponentParams: { tooltip: 'GFS Date' },
            maxWidth: 70,
         },
         {
            field: 'status',
            headerName: 'STATUS',
            headerComponentParams: { tooltip: 'Status' },
            maxWidth: 50,
         },
         {
            field: 'dgNumber',
            headerName: 'DG',
            headerComponentParams: { tooltip: 'DG Number' },
            maxWidth: 68,
            minWidth: 68,
         },
         {
            field: 'userActionCode',
            headerName: 'UAC',
            headerComponentParams: { tooltip: 'UAC' },
            maxWidth: 50,
         },
      ],
   },
   {
      headerName: 'FARE CLASS',
      headerComponentParams: { tooltip: 'Fare Class' },
      children: [
         {
            field: 'cabinCode',
            headerName: 'CAB',
            headerComponentParams: { tooltip: 'Cabin Code' },
            maxWidth: 50,
         },
         {
            field: 'rbds',
            headerName: 'RBD',
            headerComponentParams: { tooltip: 'RBDs' },
            maxWidth: 50,
         },
         {
            field: 'fareTypeCode',
            headerName: 'FTC',
            headerComponentParams: { tooltip: 'Fare Type Code' },
            maxWidth: 50,
         },
         {
            field: 'dayOfWeekTypeCode',
            headerName: 'DOW TC',
            headerComponentParams: { tooltip: 'Day of Week Type Code' },
            maxWidth: 52,
         },
         {
            field: 'seasonTypeCode',
            headerName: 'SEAS TC',
            headerComponentParams: { tooltip: 'Season Type Code' },
            maxWidth: 60,
         },
         {
            field: 'passengerTypes',
            headerName: 'PTC',
            headerComponentParams: { tooltip: 'Passenger Types' },
            maxWidth: 50,
         },
         {
            field: 'ticketDesignators',
            headerName: 'TKT DSG',
            headerComponentParams: { tooltip: 'Ticket Designators' },
            maxWidth: 84,
            tooltipField: 'ticketDesignators',
         },
      ],
   },
   {
      headerName: 'BRAND',
      headerComponentParams: { tooltip: 'Brand' },
      children: [
         {
            field: 'brand',
            headerName: 'BRD',
            headerComponentParams: { tooltip: 'Brand' },
            maxWidth: 50,
         },
         {
            field: 'branddetails',
            headerName: 'BRD DET',
            headerComponentParams: { tooltip: 'Brand Details' },
            maxWidth: 60,
         },
      ],
   },
   {
      headerName: 'MARKET',
      headerComponentParams: { tooltip: 'Market' },
      children: [
         {
            field: 'originCountryCode',
            headerName: 'OC',
            headerComponentParams: { tooltip: 'Origin Country Code' },
            maxWidth: 50,
         },
         {
            field: 'destinationCountryCode',
            headerName: 'DC',
            headerComponentParams: { tooltip: 'Destination Country Code' },
            maxWidth: 50,
         },
         {
            field: 'mkt',
            headerName: 'MKT',
            headerComponentParams: { tooltip: 'Market' },
            maxWidth: 50,
         },
         {
            field: 'src',
            headerName: 'SRC',
            headerComponentParams: { tooltip: 'Source' },
            maxWidth: 50,
         },
         {
            field: 'tier',
            headerName: 'TIER',
            headerComponentParams: { tooltip: 'Tier' },
            maxWidth: 50,
         },
         {
            field: 'mktGrp',
            headerName: 'MKT GRP',
            headerComponentParams: { tooltip: 'Market Group' },
            maxWidth: 60,
         },
         {
            field: 'mktTyp',
            headerName: 'MKT TYP',
            headerComponentParams: { tooltip: 'Market Type' },
            maxWidth: 60,
         },
         {
            field: 'mktAst',
            headerName: 'MKT AST',
            headerComponentParams: { tooltip: 'Market Association' },
            maxWidth: 60,
         },
         {
            field: 'mktCat',
            headerName: 'MKT CAT',
            headerComponentParams: { tooltip: 'Market Category' },
            maxWidth: 60,
         },
      ],
   },
];
export const constructedFaresTableHeaders = [
   {
      headerName: 'IDENTIFIER',
      headerComponentParams: { tooltip: 'Identifier' },
      children: [
         {
            field: 'origin',
            headerName: 'ORG',
            headerComponentParams: { tooltip: 'Origin' },
            pinned: 'left',
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: originValueSetter,
         },
         {
            field: 'destination',
            headerName: 'DES',
            headerComponentParams: { tooltip: 'Destination' },
            pinned: 'left',
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: destinationValueSetter,
         },
         {
            field: 'carrierCode',
            headerName: 'CXR',
            headerComponentParams: { tooltip: 'Carrier Code' },
            pinned: 'left',
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: carrierCodeValueSetter,
         },
         {
            field: 'fareClassCode',
            headerName: 'FBC',
            headerComponentParams: { tooltip: 'Fare Class Code' },
            pinned: 'left',
            minWidth: 72,
            maxWidth: 72,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: fareClassCodeValueSetter,
         },
         {
            field: 'tariffNumber',
            headerName: 'TAR',
            headerComponentParams: { tooltip: 'Tariff Number' },
            pinned: 'left',
            cellStyle: { textAlign: 'right' },
            maxWidth: 50,
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: tariffNumberValueSetter,
         },
         {
            field: 'footnoteCode',
            headerName: 'FT',
            headerComponentParams: { tooltip: 'Footnote Code' },
            pinned: 'left',
            maxWidth: 50,
            editable: true,
            valueSetter: footnoteCodeValueSetter,
         },

         {
            field: 'routingNumber',
            headerName: 'RTG',
            headerComponentParams: { tooltip: 'Routing Number' },
            pinned: 'left',
            maxWidth: 50,
            cellStyle: { textAlign: 'right' },
            editable: true,
            valueSetter: routingNumberValueSetter,
         },
         {
            field: 'constructionMethod',
            headerName: 'CON',
            headerComponentParams: { tooltip: 'Construction Method' },
            pinned: 'left',
            maxWidth: 50,
         },
      ],
   },
   {
      headerName: 'FARE VALUE',
      headerComponentParams: { tooltip: 'Fare Value' },
      children: [
         {
            field: 'vendorChangeCode',
            headerName: 'VCC',
            headerComponentParams: { tooltip: 'Vendor Change Code' },
            maxWidth: 50,
         },
         {
            field: 'roundTripIndicator',
            headerName: 'OWRT',
            headerComponentParams: { tooltip: 'Round Trip Indicator' },
            maxWidth: 50,
            cellStyle: { textAlign: 'right' },
            editable: ({ data }) =>
               data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.NEW,
            valueSetter: roundTripIndicatorValueSetter,
         },
         {
            field: 'currencyCode',
            headerName: 'CUR',
            headerComponentParams: { tooltip: 'Currency Code' },
            maxWidth: 50,
            editable: true,
            valueSetter: currencyCodeValueSetter,
         },
         {
            field: 'fareAmount',
            headerName: 'AMT',
            headerComponentParams: { tooltip: 'Fare Amount' },
            maxWidth: 72,
            cellStyle: { textAlign: 'right' },
            editable: true,
            valueSetter: amountColumnValueSetter,
         },
         {
            field: 'surchargeAmount',
            headerName: 'SUR',
            headerComponentParams: { tooltip: 'Surcharge Amount' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'yqAmount',
            headerName: 'YQ',
            headerComponentParams: { tooltip: 'YQ Amount' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'yrAmount',
            headerName: 'YR',
            headerComponentParams: { tooltip: 'YR Amount' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'aggregatedTax',
            headerName: 'TAX',
            headerComponentParams: { tooltip: 'Aggregated Tax' },
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'totalFare',
            headerName: 'TTL',
            headerComponentParams: { tooltip: 'Total Fare' },
            maxWidth: 56,
            cellStyle: { textAlign: 'right' },
         },
      ],
   },
   {
      headerName: 'RULE',
      headerComponentParams: { tooltip: 'Rule' },
      children: [
         {
            field: 'ruleNumber',
            headerName: 'RULE',
            headerComponentParams: { tooltip: 'Rule Number' },
            maxWidth: 50,
         },
         {
            field: 'dow',
            headerName: 'DOW',
            headerComponentParams: { tooltip: 'Day of Week' },
            maxWidth: 140,
         },
         {
            field: 'ruleSeasonDates',
            headerName: 'SEAS DT',
            headerComponentParams: { tooltip: 'Season Dates' },
            maxWidth: 136,
            tooltipField: 'ruleSeasonDates',
         },
         {
            field: 'advancePurchaseReservation',
            headerName: 'AP',
            headerComponentParams: { tooltip: 'Advance Purchase Reservation' },
            maxWidth: 50,
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'ruleTravelDates',
            headerName: 'RULE TVL DT',
            headerComponentParams: { tooltip: 'Rule Travel Dates' },
            maxWidth: 136,
            tooltipField: 'ruleTravelDates',
         },
         {
            field: 'applicableDates',
            headerName: 'APPL DT',
            headerComponentParams: { tooltip: 'Applicable Dates' },
            maxWidth: 136,
            tooltipField: 'applicableDates',
         },
         {
            field: 'minStay',
            headerName: 'MIN ST',
            headerComponentParams: { tooltip: 'Minimum Stay' },
            maxWidth: 136,
            tooltipField: 'minStay',
         },
         {
            field: 'maxStay',
            headerName: 'MAX ST',
            headerComponentParams: { tooltip: 'Maximum Stay' },
            tooltipField: 'maxStay',
            cellStyle: { textAlign: 'right' },
         },
         {
            field: 'ruleBlackOutDates',
            headerName: 'BO DT',
            headerComponentParams: { tooltip: 'Black Out Dates' },
            maxWidth: 136,
            tooltipField: 'ruleBlackOutDates',
            cellStyle: { textAlign: 'right' },
         },
      ],
   },
   {
      headerName: 'FOOTNOTE',
      headerComponentParams: { tooltip: 'Footnote' },
      children: [
         {
            field: 'footnoteReservationFromDate',
            headerName: 'FST RES',
            headerComponentParams: {
               tooltip: 'Footnote Reservation From Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteReservationToDate',
            headerName: 'LST RES',
            headerComponentParams: { tooltip: 'Footnote Reservation To Date' },
            maxWidth: 76,
         },
         {
            field: 'footnoteTicketingFromDate',
            headerName: 'FST TKT',
            headerComponentParams: { tooltip: 'Footnote Ticketing From Date' },
            maxWidth: 76,
         },
         {
            field: 'footnoteTicketingToDate',
            headerName: 'LST TKT',
            headerComponentParams: { tooltip: 'Footnote Ticketing To Date' },
            maxWidth: 76,
         },
         {
            field: 'footnoteOutboundTravelFromDate',
            headerName: 'TVL ST',
            headerComponentParams: {
               tooltip: 'Footnote Outbound Travel From Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteOutboundTravelToDate',
            headerName: 'TVL END',
            headerComponentParams: {
               tooltip: 'Footnote Outbound Travel To Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteOutboundTravelCompleteDate',
            headerName: 'TVL CMPLT',
            headerComponentParams: {
               tooltip: 'Footnote Outbound Travel Complete Date',
            },
            maxWidth: 76,
         },
         {
            field: 'footnoteTravelDates',
            headerName: 'FT TVL DT',
            headerComponentParams: { tooltip: 'Footnote Travel Dates' },
            maxWidth: 136,
            tooltipField: 'footnoteTravelDates',
         },
         {
            field: 'footnoteSeasonDates',
            headerName: 'FT SEAS DT',
            headerComponentParams: { tooltip: 'Footnote Season Dates' },
            maxWidth: 136,
            tooltipField: 'footnoteSeasonDates',
         },
         {
            field: 'footnoteBlackOutDates',
            headerName: 'FT BO DT',
            headerComponentParams: { tooltip: 'Footnote Black Out Dates' },
            maxWidth: 136,
            tooltipField: 'footnoteBlackOutDates',
         },
      ],
   },
   {
      headerName: 'DISTRIBUTION',
      headerComponentParams: { tooltip: 'Distribution' },
      children: [
         {
            field: 'effectiveDate',
            headerName: 'EFF DT',
            headerComponentParams: { tooltip: 'Effective Date' },
            maxWidth: 70,
            editable: true,
            valueSetter: effectiveDateValueSetter,
         },
         {
            field: 'discontinueDate',
            headerName: 'DISC DT',
            headerComponentParams: { tooltip: 'Discontinue Date' },
            maxWidth: 70,
            editable: true,
            valueSetter: discontinueDateValueSetter,
         },
         {
            field: 'receivedDate',
            headerName: 'REC DT',
            headerComponentParams: { tooltip: 'Transmission Date Time' },
            maxWidth: 132,
         },
         {
            field: 'gfsUniqueFillingCode',
            headerName: 'GFS',
            headerComponentParams: { tooltip: 'GFS Unique Filling Code' },
            maxWidth: 50,
         },
         {
            field: 'gfsDate',
            headerName: 'GFS DT',
            headerComponentParams: { tooltip: 'GFS Date' },
            maxWidth: 70,
         },
         {
            field: 'status',
            headerName: 'STATUS',
            headerComponentParams: { tooltip: 'Status' },
            maxWidth: 50,
         },
         {
            field: 'dgNumber',
            headerName: 'DG',
            headerComponentParams: { tooltip: 'DG Number' },
            maxWidth: 68,
            minWidth: 68,
         },
         {
            field: 'userActionCode',
            headerName: 'UAC',
            headerComponentParams: { tooltip: 'UAC' },
            maxWidth: 50,
         },
      ],
   },
   {
      headerName: 'FARE CLASS',
      headerComponentParams: { tooltip: 'Fare Class' },
      children: [
         {
            field: 'cabinCode',
            headerName: 'CAB',
            headerComponentParams: { tooltip: 'Cabin Code' },
            maxWidth: 50,
         },
         {
            field: 'rbds',
            headerName: 'RBD',
            headerComponentParams: { tooltip: 'RBDs' },
            maxWidth: 50,
         },
         {
            field: 'fareTypeCode',
            headerName: 'FTC',
            headerComponentParams: { tooltip: 'Fare Type Code' },
            maxWidth: 50,
         },
         {
            field: 'dayOfWeekTypeCode',
            headerName: 'DOW TC',
            headerComponentParams: { tooltip: 'Day of Week Type Code' },
            maxWidth: 52,
         },
         {
            field: 'seasonTypeCode',
            headerName: 'SEAS TC',
            headerComponentParams: { tooltip: 'Season Type Code' },
            maxWidth: 60,
         },
         {
            field: 'passengerTypes',
            headerName: 'PTC',
            headerComponentParams: { tooltip: 'Passenger Types' },
            maxWidth: 50,
         },
         {
            field: 'ticketDesignators',
            headerName: 'TKT DSG',
            headerComponentParams: { tooltip: 'Ticket Designators' },
            maxWidth: 84,
            tooltipField: 'ticketDesignators',
         },
      ],
   },
   {
      headerName: 'BRAND',
      headerComponentParams: { tooltip: 'Brand' },
      children: [
         {
            field: 'brand',
            headerName: 'BRD',
            headerComponentParams: { tooltip: 'Brand' },
            maxWidth: 50,
         },
         {
            field: 'branddetails',
            headerName: 'BRD DET',
            headerComponentParams: { tooltip: 'Brand Details' },
            maxWidth: 60,
         },
      ],
   },
   {
      headerName: 'MARKET',
      headerComponentParams: { tooltip: 'Market' },
      children: [
         {
            field: 'originCountryCode',
            headerName: 'OC',
            headerComponentParams: { tooltip: 'Origin Country Code' },
            maxWidth: 50,
         },
         {
            field: 'destinationCountryCode',
            headerName: 'DC',
            headerComponentParams: { tooltip: 'Destination Country Code' },
            maxWidth: 50,
         },
         {
            field: 'mkt',
            headerName: 'MKT',
            headerComponentParams: { tooltip: 'Market' },
            maxWidth: 50,
         },
         {
            field: 'src',
            headerName: 'SRC',
            headerComponentParams: { tooltip: 'Source' },
            maxWidth: 50,
         },
         {
            field: 'tier',
            headerName: 'TIER',
            headerComponentParams: { tooltip: 'Tier' },
            maxWidth: 50,
         },
         {
            field: 'mktGrp',
            headerName: 'MKT GRP',
            headerComponentParams: { tooltip: 'Market Group' },
            maxWidth: 60,
         },
         {
            field: 'mktTyp',
            headerName: 'MKT TYP',
            headerComponentParams: { tooltip: 'Market Type' },
            maxWidth: 60,
         },
         {
            field: 'mktAst',
            headerName: 'MKT AST',
            headerComponentParams: { tooltip: 'Market Association' },
            maxWidth: 60,
         },
         {
            field: 'mktCat',
            headerName: 'MKT CAT',
            headerComponentParams: { tooltip: 'Market Category' },
            maxWidth: 60,
         },
      ],
   },
   {
      headerName: 'ORIGIN ADDON',
      headerComponentParams: { tooltip: 'Origin Addon' },
      children: [
         {
            field: 'originAddOn.gatewayCityCode',
            headerName: 'GWT CITY',
            headerComponentParams: { tooltip: 'Gateway City Code' },
            maxWidth: 50,
         },
         {
            field: 'originAddOn.fareClassCode',
            headerName: 'FCC',
            headerComponentParams: { tooltip: 'Fare Class Code' },
            maxWidth: 72,
         },
         {
            field: 'originAddOn.footnoteCode',
            headerName: 'FT',
            headerComponentParams: { tooltip: 'Footnote Code' },
            maxWidth: 50,
         },
         {
            field: 'originAddOn.arbTariffNumber',
            headerName: 'TAR',
            headerComponentParams: { tooltip: 'Addon Tariff Number' },
            maxWidth: 50,
         },
         {
            field: 'originAddOn.amount',
            headerName: 'AMT',
            headerComponentParams: { tooltip: 'Addon Amount' },
            maxWidth: 72,
         },
         {
            field: 'originAddOn.currency',
            headerName: 'CUR',
            headerComponentParams: { tooltip: 'Currency Code' },
            maxWidth: 60,
         },
      ],
   },
   {
      headerName: 'DESTINATION ADDON',
      headerComponentParams: { tooltip: 'Destination Addon' },
      children: [
         {
            field: 'destinationAddOn.gatewayCityCode',
            headerName: 'GWT CITY',
            headerComponentParams: { tooltip: 'Gateway City Code' },
            maxWidth: 50,
         },
         {
            field: 'destinationAddOn.fareClassCode',
            headerName: 'FCC',
            headerComponentParams: { tooltip: 'Fare Class Code' },
            maxWidth: 72,
         },
         {
            field: 'destinationAddOn.footnoteCode',
            headerName: 'FT',
            headerComponentParams: { tooltip: 'Footnote Code' },
            maxWidth: 50,
         },
         {
            field: 'destinationAddOn.arbTariffNumber',
            headerName: 'TAR',
            headerComponentParams: { tooltip: 'Addon Tariff Number' },
            maxWidth: 50,
         },
         {
            field: 'destinationAddOn.amount',
            headerName: 'AMT',
            headerComponentParams: { tooltip: 'Addon Amount' },
            maxWidth: 72,
         },
         {
            field: 'destinationAddOn.currency',
            headerName: 'CUR',
            headerComponentParams: { tooltip: 'Currency Code' },
            maxWidth: 60,
         },
      ],
   },
   {
      headerName: 'SPECIFIED FARE',
      headerComponentParams: { tooltip: 'Specified Fare' },
      children: [
         {
            field: 'specifiedFare.specifiedFareOrigin',
            headerName: 'SPEC ORG',
            headerComponentParams: { tooltip: 'Specified Fare Origin' },
            maxWidth: 72,
         },
         {
            field: 'specifiedFare.specifiedFareDestination',
            headerName: 'SPEC DEST',
            headerComponentParams: { tooltip: 'Specified Fare Destination' },
            maxWidth: 72,
         },
         {
            field: 'specifiedFare.specifiedFareAmount',
            headerName: 'SPEC AMT',
            headerComponentParams: { tooltip: 'Specified Fare Amount' },
            maxWidth: 72,
         },
         {
            field: 'specifiedFare.specifiedFareCurrency',
            headerName: 'SPEC CURR',
            headerComponentParams: { tooltip: 'Specified Fare Currency' },
            maxWidth: 72,
         },
      ],
   },
];
